var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layoutWrapper"},[_c('header',[_vm._v("点滴记账")]),_c('div',{staticClass:"content",class:_vm.classPrefix && (_vm.classPrefix + "Content")},[_vm._t("default")],2),_c('Navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }